<template>
	<div class="keyword-list-main-div">
		<div class="head-div">
			<div style="flex: 1">
				<el-input v-model="search.keywords" placeholder="输入关键词搜索"></el-input>
			</div>
			<div style="margin-left: 15px">
				<el-button @click="searchFun(null)" :disabled="loading">
					<span v-if="loading" class="el-icon-loading"></span>
					<span v-else class="el-icon-search"></span>
				</el-button>
				<el-button type="primary" @click="openAddAsinDialog()">添加商品</el-button>
				<el-button type="primary" @click="openAddKeywordsDialog()">添加关键词</el-button>
				<el-button type="danger" @click="openDelAsinDialog()">删除商品</el-button>
			</div>
		</div>
		<div class="body-div">
			<el-table :data="searchData.list" class="el-table-20220806" height="100%"
				ref="el-table"
				header-row-class-name="el-table-header-20220806" v-loading="loading">
				<el-table-column type="selection" width="55"></el-table-column>

				<el-table-column prop="keywords" label="搜索词" min-width="440" fixed="left"
					header-align="center">
					<template slot-scope="scope">
						<div class="keywords-box">
							<div class="keywords-text-span overflow-two-line">
								<a :href="'/index/weekly_keyword?country=US&searchTerm=' + scope.row.keywords " target="_blank">
									{{ scope.row.keywords }}
								</a>
							</div>
							<!--操作-->
							<div style="flex-shrink:0;">
								<copy-sub :value="scope.row.keywords"></copy-sub>

<!--								<a style="margin-left:5px;">-->
<!--									&lt;!&ndash; 关键字相关详细 标签&ndash;&gt;-->
<!--									<i class="el-icon-s-data el-icon-document"-->
<!--										@click="openKeywordTrendsDialog(scope.row.keywords)"></i>-->
<!--								</a>-->

								<el-tooltip effect="light" placement="top-start" :content="'关键词分析'">
									<a target="_blank" style="margin-left:5px;"
										:href="'/index/keyword_analysis?country=US&search_term=' + scope.row.keywords">
										<i class="fa fa-line-chart" aria-hidden="true"></i>
									</a>
								</el-tooltip>

								<el-tooltip effect="light" placement="top-start" :content="'在亚马逊中搜索'">
									<a target="_blank" style="margin-left:5px;"
										:href="'https://www.' + getCountryObjByCity('US').department + '/gp/search?ie=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=08300d56d65209635109611e3b030de0&camp=1789&creative=9325&index=aps&keywords=' + scope.row.keywords"><i
										class="fa fa-plane" aria-hidden="true"></i></a>
								</el-tooltip>

								<el-tooltip effect="light" placement="top-start" :content="'在Google中搜索'">
									<a target="_blank" style="margin-left:5px;"
										:href="'https://trends.google.com/trends/explore?geo=US' + '&q=' + scope.row.keywords"><i
										class="fa fa-google" aria-hidden="true"></i></a>
								</el-tooltip>

								<el-popover placement="right" trigger="hover" width="auto" :close-delay="200">
									<div class="asin-box-div">
										<div v-if="scope.row.pageData && scope.row.pageData.length > 0">
											<div class="asin-div" v-for="(item,index) in scope.row.pageData" :key="index">
												<el-tooltip ref="tooltip"  effect="dark" :placement="'top'" :enterable="false">
													<div slot="content" style="max-width:500px" >
														{{ item.title }}
													</div>
													<div class="img-div">
														<el-image style="height: 110px;width: 110px" fit="contain"
															:src="imgSizeSet(JSON.parse(item.imgs || '')[0],250)"></el-image>
														<div class="ranking-div">
															{{ index + 1 }}
														</div>
													</div>
												</el-tooltip>
												<div style="font-size: 12px;">
													<div style="text-align: left;">
														<span style="color: #F56C6C;" v-if="item.price">
															${{ item.price }}&nbsp;&nbsp;
														</span>
														<span v-else class="no-data-font"> -- </span>
														<span style="float: right;color: #909399;">
															<span>{{ unitConversion(item.commentNum || 0) }}</span>
															<span>({{ item.score }})</span>
														</span>
													</div>
													<div>
														<a class="underline-dashed-line" :href="item.url">{{ item.asin }}</a>
														<copy-sub :value="item.asin"></copy-sub>
														<a target="_blank" :href="item.url" style="margin-left: 5px;">
															<i class="el-icon-paperclip"></i>
														</a>
													</div>
													<div style="margin-top: 5px">
														<el-tooltip :enterable="false" effect="dark" content="查流量来源" placement="top-start">
															<a target="_blank" :href="'/index/traffic_source?asin=' + item.asin + '&country=US' ">
																<el-tag size="mini" type="primary" effect="plain">查</el-tag>
															</a>
														</el-tooltip>
														<el-tooltip :enterable="false" effect="dark" content="反查流量词" placement="top-start">
															<a style="margin-left: 5px" target="_blank"
																:href="'/index/reverse?asin=' + item.asin + '&country=US' ">
																<el-tag size="mini" type="primary" effect="plain">反</el-tag>
															</a>
														</el-tooltip>
														<!-- <el-tooltip :enterable="false" effect="dark" content="评论分析" placement="top-start">
															<a style="margin-left: 5px" target="_blank" :href="'https://www.zi4.com/dp/' + item.asin">
																<el-tag size="mini" type="primary" effect="plain">评</el-tag>
															</a>
														</el-tooltip>
														<el-tooltip :enterable="false" effect="dark" content="站外分析" placement="top-start">
															<a style="margin-left: 5px" target="_blank" :href="'https://www.chazhanwai.com/?q=' + item.asin + '&country=US'">
																<el-tag size="mini" type="primary" effect="plain">站</el-tag>
															</a>
														</el-tooltip> -->
													</div>
												</div>
											</div>
										</div>
										<div v-else>
											<el-empty :image-size="150"></el-empty>
										</div>
									</div>
									<i class="fa fa-compass" aria-hidden="true" slot="reference"
										style="margin-left: 5px;cursor: pointer;color: #F56C6C;font-size: 16px"></i>
								</el-popover>
							</div>
						</div>
						<div class="color-text-grey-1 overflow-one-line">
							{{ translation[scope.row.keywords] }}
						</div>
					</template>
				</el-table-column>

				<el-table-column label="月搜索量" align="center" width="100px">
					<template slot-scope="scope">
						<span v-if="keywordsTrends[scope.row.keywords]">
							{{  toThousands(keywordsTrends[scope.row.keywords].search_volume) }}
						</span>
						<span v-else class="no-data-font"> -- </span>
					</template>
				</el-table-column>

				<el-table-column label="搜索量趋势" align="center" width="200">
					<template slot-scope="scope">
						<div>
							{{ void(trends=keywordsTrends[scope.row.keywords] )}}
							<chart-sub :data_height="80"
								:option="getChartOption(scope.row.keywords,trends ? trends.search_trend : [])"></chart-sub>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="排名趋势" align="center" width="200">
					<template slot-scope="scope">
						<div style="min-height: 80px;"
							v-loading="!scope.row.rankTrends">
							<div v-if="scope.row.rankTrends" >
								<chart-sub :data_height="80"
									:option="getChartOption2(scope.row.rankTrends)"></chart-sub>
							</div>
							<span v-else class="no-data-font-1"></span>
						</div>
					</template>
				</el-table-column>

				<el-table-column v-for="(asin,index) in searchData.asinList"
					align="center" width="120px" :key="index" :prop="'asin-' + index">
					<template slot="header" slot-scope="scope">
						{{ void(asinInfo=asinInfoList.find(i => i.asin === asin)) }}
						<div style="font-size: 12px;font-weight: normal;" v-loading="loadAsinLock">
							<el-image :src="asinInfo ? (asinInfo.imgs[0] || '') : ''" style="height: 48px;width: 48px;" fit="contain">
								<div slot="error" class="div-border-1" style="line-height: 45px;">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
							<div style="display: flex">
								<div>
									<div class="th-dot-div"></div>
								</div>
								<div style="flex: 1;">{{ asin }}</div>
							</div>
						</div>
					</template>
					<template slot-scope="scope">
						<div>
							{{ void(asinData=searchData.asinData.find(i => i.taskId===scope.row.id && i.asin === asin))}}
							<div  style="cursor: pointer;" :key="asin" @click="openAsinHistoryDialog(scope.row.id,asin)">
								<div v-if="asinData && (asinData.absolutePosition || asinData.adAbsolutePosition || asinData.tag)">
									<div style="line-height: 16px">
										<el-tooltip class="item" effect="dark" content="自然排名" placement="left">
											<div>
										<span v-if="asinData.absolutePosition" class="color-text-blue">
											{{ asinData.absolutePosition }}
											(P{{ asinData.currentPage }} - {{ asinData.position }})
										</span>
												<span v-else class="no-data-font-1"></span>
											</div>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" content="广告排名" placement="left">
											<div>
											<span v-if="asinData.adAbsolutePosition" class="emphasis-hint">
												{{ asinData.adAbsolutePosition }}
												(P{{ asinData.adCurrentPage }} - {{ asinData.adPosition }})
											</span>
												<span v-else class="no-data-font-1"></span>
											</div>
										</el-tooltip>
									</div>
									<div class="color-text-grey-2" style="font-size: 12px">
										{{ void (tag=JSON.parse(asinData.tag || '[]'))}}
										<span  v-if="tag && tag.length > 0">
										<span v-if="tag.indexOf('ac') !== -1">AC&nbsp;</span>
										<span v-if="tag.indexOf('tr') !== -1">TR&nbsp;</span>
										<span v-if="tag.indexOf('bs') !== -1">BS</span>
									</span>
										<span v-else class="no-data-font-1"></span>
									</div>
								</div>
								<div v-else class="no-data-font-1"></div>
							</div>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="test" label="类目" align="center" width="120px" fixed="right">
					<template slot-scope="scope">
						<el-tag type="warning" size="small">
							{{ scope.row.categoryId ? scope.row.categoryId : 'ALL Departments' }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="跟踪状态" align="center" width="80" fixed="right">
					<template slot-scope="scope">
						{{ void (distanceTime = getDistanceTime(scope.row.expirationDate, new Date())) }}
						<el-tooltip class="item" effect="dark" placement="top-start">
							<div slot="content">
								{{
									void (overdue = new Date(scope.row.expirationDate).getTime() > new Date().getTime())
								}}
								<div v-if="overdue">
									剩余 {{ distanceTime[0] }}天 {{ distanceTime[1] }}小时
								</div>
								<div v-else>已经过期了 {{ Math.abs(distanceTime[0]) }}天 {{
										Math.abs(distanceTime[1])  || 0
									}}小时
								</div>
								<br/>
								<div>过期时间: {{ $fomatTime(scope.row.expirationDate, 'yyyy-MM-DD HH:mm') }}</div>
							</div>

							<div v-if="overdue" class="dot-div"
								:style="'color:' + (distanceTime[0] > 3 ? '#67C23A;' : '#E6A23C')"></div>
							<div v-else class="dot-div" style="color:#F56C6C;"></div>
						</el-tooltip>
					</template>
				</el-table-column>

				<el-table-column width="60px" align="center" fixed="right">
					<template slot-scope="scope">
						<div class="operation-div">
							<div>
								<el-dropdown @command="(v) => {handleCommand(v,scope.row)}" >
									<el-button type="text">详情</el-button>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item command="2">商品详情</el-dropdown-item>
										<el-dropdown-item command="1" :disabled="!scope.row. latestDataId">关键词详情</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
							<div>
								<el-button type="text" @click="openUpdateKeyword(scope.row)">配置</el-button>
							</div>
							<div>
								<el-button type="text" @click="openRechargeKeyword(scope.row)" >续期</el-button>
							</div>
							<div>
								<el-button type="text" @click="delKeywords(null,scope.row.id)">删除</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--				分页-->
		<div class="tab-foot-page-div">
			<page-sub :background="true" layout="sizes,prev, pager, next"
				:page-sizes="[10,20, 30, 50]"
				@current-change="pageChange" @size-change="handleSizeChange"
				:total="searchData.total" :page-size="search.pageSize"
				:current-page="search.page"/>
		</div>
		<!--附加悬浮窗-->
		<!-- 查看关键字搜索趋势 -->
		<el-dialog width="1000px" top="50px" :show-close="false" :append-to-body="true"
			v-if="searchVolumeShowObj.dialogVisible"
			:visible.sync="searchVolumeShowObj.dialogVisible" direction="btt" destroy-on-close>
			<div slot="title" style="text-align: right;">
				<el-button @click="searchVolumeShowObj.dialogVisible=false" type="danger" icon="el-icon-close"
					size="mini"></el-button>
			</div>

			<div style="height: 600px">
				<keywords-related-list :keywords="searchVolumeShowObj.keyword" country="US"></keywords-related-list>
			</div>

		</el-dialog>
		<!--asin历史排名-->
		<el-dialog v-if="asinHistory.visible" :visible.sync="asinHistory.visible" width="1000px">
			<asin-rank-trends-sub :asin-task-id="asinHistory.asinTaskId"></asin-rank-trends-sub>
		</el-dialog>
		<!-- 编辑关键字配置 -->
		<el-drawer :visible.sync="updateKeywordConfigObj.dialogVisible" size="400px"
			direction="rtl" v-if="updateKeywordConfigObj.dialogVisible" v-loading="updateKeywordConfigObj.loading">
			<template slot="title">
				<h2 size="3" style="color:#F56C6C ;" class="overflow-one-line">
					{{ updateKeywordConfigObj.keywordConfig.keywords }}
				</h2>
			</template>
			<div class="update-keyword-body">
				<div class="config-div">
					<h4 class="tag-title">配置</h4>
					<el-divider></el-divider>
					<el-form label-width="80px">
						<el-form-item label="搜索页码">
							<el-row>
								<el-col :span="21">
									<el-input-number disabled style="width: 90%;"
										:min="1" :max="10"
										v-model="updateKeywordConfigObj.keywordConfig.endPage"></el-input-number>
								</el-col>
								<el-col :span="3">
									页
								</el-col>
							</el-row>
						</el-form-item>
						<el-form-item label="追踪间隔">
							<el-row>
								<el-col :span="21">
									<el-input-number :min="2" style="width: 90%;"
										v-model="updateKeywordConfigObj.keywordConfig.period"></el-input-number>
								</el-col>
								<el-col :span="3">
									小时
								</el-col>
							</el-row>

						</el-form-item>
						<el-form-item label="搜索类目">
							<el-col :span="21">
								<el-select style="width: 90%;" disabled
									v-model="updateKeywordConfigObj.keywordConfig.categoryId">
									<el-option label="ALL Departments" :value="0"></el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</el-form>
				</div>

				<el-divider></el-divider>
				<div class="next-run-time-div">
					<h4 class="tag-title">下次追踪时间</h4>
					<div class="list-time-box">
						<el-row>
							<el-col
								v-for="(item,index) in getTimeList(updateKeywordConfigObj.keywordConfig.taskCompletionTime || updateKeywordConfigObj.keywordConfig.createTime,updateKeywordConfigObj.keywordConfig.period,10)"
								:key="index" :span="12">
								{{ $timezone(item, 'YYYY-MM-DD HH:mm') }}
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
			<div class="demo-drawer-footer">
				<el-button @click="updateKeywordConfigObj.dialogVisible=false">取 消</el-button>
				<el-button type="primary" @click="updateConfig(null)">提交</el-button>
			</div>
		</el-drawer>
		<!--删除ASIN-->
		<el-dialog :visible.sync="delAsin.visible" :show-close="false" width="950px"
			top="100px" v-if="delAsin.visible" v-loading="delAsin.loading"
			destroy-on-close append-to-body>
			<div slot="title" style="text-align: right;">
				<el-button @click="delAsin.visible=false" type="danger" icon="el-icon-close" size="mini"></el-button>
			</div>
			<div>
				<el-card shadow="never" style="max-height: 580px;overflow-y: auto">
					<el-row :gutter="10">
						<el-col :span="3" v-for="(asin,index) in searchData.asinList" :key="index" v-loading="loadAsinLock">
							{{ void(asinInfo=asinInfoList.find(i => i.asin === asin)) }}
							<asin-sub :show-rank="false"  :asin-info="asinInfo || {asin : asin}">
								<div class="div-border-1 del-asin-card" @click="delAsinCheck(asin)" style="cursor: pointer;">
									<el-image :src="asinInfo ? (asinInfo.imgs[0] || '') : ''"
										style="width: 100%;aspect-ratio:1/1" fit="contain">
										<div slot="error" style="font-size: 14px;text-align: center;line-height: 86px">
											{{ asin }}
										</div>
									</el-image>
									<el-checkbox  class="check-box"
										v-model="delAsin.checkedAsinS.indexOf(asin) !== -1"></el-checkbox>
								</div>
							</asin-sub>
						</el-col>
					</el-row>
				</el-card>
			</div>

			<div slot="footer">
				<el-button size="small" @click="delAsin.visible=false">取 消</el-button>
				<el-button size="small" type="danger"
					:disabled="delAsin.checkedAsinS.length <= 0" @click="delAsinFun()">确定删除</el-button>
			</div>
		</el-dialog>
		<!-- 充值 -->
		<el-dialog :visible.sync="rechargeConfigObj.dialogVisible" :show-close="false"
			width="950px" destroy-on-close :append-to-body="true"
			@close="rechargeConfigObj.keywordTitles=[];rechargeConfigObj.keywordIds =[]">
			<div slot="title" style="text-align: right;">
				<el-button @click="rechargeConfigObj.dialogVisible=false" type="danger" icon="el-icon-close"
					size="mini"></el-button>
			</div>
			<keyword-recharge-sub @succeed="rechargeKeywordSucceed"
				type="add_keyword_monitoring2"
				:keywordTitles="rechargeConfigObj.keywordTitles"
				:keywordIds="rechargeConfigObj.keywordIds"></keyword-recharge-sub>
		</el-dialog>
		<!--增加新的ASIN追踪-->
		<el-dialog v-if="addAsin.visible" :visible.sync="addAsin.visible" width="700px" :show-close="false" v-loading="addAsin.loading ">
			<div slot="title" class="add-asin-title card-title">
				<el-button  type="danger" style="float:right;" size="mini" @click="addAsin.visible=false" icon="el-icon-close"></el-button>
			</div>
			<el-input v-model="addAsin.asin">
				<template slot="prepend"><i :class="getCountryByValue().icon2"></i></template>
				<el-button :disabled="addAsin.searchLoading" v-loading="addAsin.searchLoading"  slot="append"  icon="el-icon-search" @click="searchAsin(null)"></el-button>
			</el-input>
			<el-card shadow="none" style="margin-top: 20px" :key="addAsin.showAsin"
				v-if="addAsin.showAsin" class="add-asin-card" v-loading="addAsin.searchLoading">
				{{ void (asinInfo = addAsin.asinDataList.find(i => i.asin === addAsin.showAsin))}}
				<div style="display: flex;">
					<div class="div-border-1" style="padding: 5px;box-sizing: border-box">
						<el-image :src="asinInfo.imgs && asinInfo.imgs.length > 0 ?
									imgSizeSet(asinInfo.imgs[0]) : ''" fit="contain"
							style="height: 55px;width:55px"></el-image>
					</div>

					<div style="flex: 1;overflow: hidden;margin-left: 10px" >
						<span v-if="asinInfo.title" class="overflow-two-line" style="font-size: 15px">
							{{ asinInfo.title }}
						</span>
						<span v-else class="no-data-font"> -- </span>
						<!--asin详细数据-->
						<div class="asin-info">
							<asin-badge-sub :asinInfo="asinInfo"></asin-badge-sub>
							<span>
								{{ asinInfo.asin }}
								<copy-sub :value="asinInfo.asin"></copy-sub>
								<a target="_blank" :href="asinInfo.url" style="margin-left:3px;">
									<i class="el-icon-paperclip"></i>
								</a>
							</span>

							<span class="emphasis-hint" v-if="asinInfo.price">
								<span>{{ getSymbolByCurrency(asinInfo.currency) }}</span>
								<span>{{ asinInfo.price }}</span>
							</span>

							<span>
								<span class="value">
									<el-rate v-model="asinInfo.score"
										disabled show-score text-color="#ff9900"
										class="el-rate-20230221" score-template="{value}"></el-rate>
									<span style="color: #ff9900;"> ({{ asinInfo.commentNum || 0 }})</span>
								</span>
							</span>
						</div>
					</div>

					<div style="margin-left: 10px;line-height: 70px">
						<el-button icon="el-icon-circle-plus" :disabled="addAsin.addAsin.indexOf(addAsin.showAsin) !== -1"
							@click="addAsin.addAsin.push(addAsin.showAsin)"
							style="padding: 8px" size="mini" type="primary"></el-button>
					</div>
				</div>
			</el-card>

			<el-card shadow="none" v-if="addAsin.addAsin && addAsin.addAsin.length > 0"
				style="max-height: 200px;margin-top: 20px;overflow-x: auto;white-space:nowrap;">
				<el-tag style="margin: 0 5px" closable @close="addAsin.addAsin.splice(index, 1)"
					v-for="(item,index) in addAsin.addAsin" :key="index">{{ item }}</el-tag>
			</el-card>
			<p class="emphasis-hint">注: 已添加过的ASIN不会重复添加</p>

			<div style="text-align: center" v-if="addAsin.addAsin && addAsin.addAsin.length > 0">
				<el-button type="primary" @click="addAsinTask(null)" size="small">
					添加
				</el-button>
				<el-button type="danger" size="small" @click="addAsin.visible=false">取消</el-button>
			</div>
		</el-dialog>
		<!--增加新的关键词追踪-->
		<el-dialog v-if="addKeywords.visible" :visible.sync="addKeywords.visible" width="700px" :show-close="false"
			v-loading="addKeywords.loading ">
			<div slot="title" style="padding:0 10px" class="add-asin-title card-title">
				<span>添加关键词</span>
				<el-button  type="danger" style="float:right;" size="mini" @click="addKeywords.visible=false" icon="el-icon-close"></el-button>
			</div>
			<div>
				<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 15}"
					:placeholder="'支持输入多个关键字' + '\n' + '请用换行分割,按住ctrl + Enter可以换行,输入完毕请按回车键'"
					v-model="addKeywords.keywordsStr"
					@keyup.enter.native="handleInputConfirm"/>
				<div>
					<el-form label-position="right" size="mini" style="margin-top: 20px;margin-bottom: 0">
						<el-row>
							<el-col :span="8">
								<el-form-item label="搜索页码">
									<el-input-number disabled :min="1" :max="10"
										v-model="addKeywords.endPage"></el-input-number>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="类目">
									<el-select disabled v-model="addKeywords.categoryId" style="width: 175px">
										<el-option label="ALL Departments" :value="null"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="追踪间隔(小时)" label-width="120px">
									<el-input-number :min="2" style="width: 100px"
										v-model="addKeywords.period"></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
			<el-card shadow="none" v-if="addKeywords.keywords && addKeywords.keywords.length > 0"
				style="max-height: 200px;margin-top: 20px;overflow-x: auto;white-space:nowrap;">
				<el-tag style="margin: 0 5px" closable @close="addKeywords.keywords.splice(index, 1)"
					v-for="(item,index) in addKeywords.keywords" :key="index">{{ item }}</el-tag>
			</el-card>
			<div style="text-align: center;margin-top: 20px">
				<el-button type="primary" :disabled="!addKeywords.keywords || addKeywords.keywords.length <= 0"
					@click="addKeywordsFun(null)" size="small">
					添加
				</el-button>
				<el-button type="danger" size="small" @click="addKeywords.visible=false">取消</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import {
	api_add_monitoring2,
	api_addAsin_monitoring2, api_asinRankTrends_monitoring2,
	api_del_monitoring2, api_delAsin_monitoring2, api_keywordsTrends_monitoring2,
	api_page_monitoring2,
	api_updateConfig_monitoring2
} from "@/components/api/keywordsMonitoring2";
import Chart from "@/components/template/otherSub/hightChartSub";
import { fomatSearchTrendsData, fomatSearchTrendsData2 } from "@/components/config/chart/kywordSearchTrendsMini";
import { toThousands, unitConversion } from "@/components/common/utils/fomatNum";
import { imgSizeSet } from "@/components/common/utils/imgUtils";
import { getDistanceTime } from "@/components/common/utils/time";
import PAGE_SUB from "@/components/template/otherSub/pageSub";
import CopySub from "@/components/template/view/keywordReverseSearch/header/navSub";
import COPY_SUB from "@/components/template/otherSub/copySub";
import { getCountryByValue, getCountryObjByCity, getSymbolByCurrency } from "@/components/config/countryCodeConfig";
import KEYWORD_RELATED_LIST from "@/components/template/view/keyword/monitoring2/keyword/keywordsRelated";
import {  throttle } from "@/components/common/utils/util";
import KEYWORD_RECHARGE_SUB from "@/components/template/view/keyword/monitoring/asinKeyword/sub/recharge";
import { api_asin_batchAsinInfoQuery_public, api_findeByAsin } from "@/components/api/asinBasiceInfo";
import { fomatRankTrendsDataMini } from "@/components/config/chart/keywordRankTrendsMini";
import ASIN_INFO_SUB from "@/components/template/view/keywordsTrend/sub/asinInfoPopoverSub";
import da from "element-ui/src/locale/lang/da";
import { formatMonitoringPositionData } from "@/components/config/chart/asinKeyword";
import ASIN_RANK_TRENDS_SUB from "@/components/template/view/keyword/monitoring2/sub/asinRankTrendsSub";

export default {
	name: "keywordListSub",
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN','KEYWORD_ADD_TAB'],
	data() {
		return {
			loading: false,
			search: {
				page: 1,
				pageSize: 10,
				keywords : null,
			},
			searchData: {
				country : 'US'
			},
			asinInfoList : [],
			loadAsinLock : false,
			// 修改关键字属性
			updateKeywordConfigObj: {
				dialogVisible: false,
				keywordConfig: null,
				loading: false
			},
			// 关键字搜索趋势属性
			searchVolumeShowObj: {
				keyword: null,
				dialogVisible: false
			},
			asinHistory : {
				visible : false,
				asinTaskId : null
			},
			rechargeConfigObj: {
				keywordIds: [],
				keywordTitles: [],
				dialogVisible: false,
			},
			addAsin : {
				asin : null,
				visible : false,
				loading :false,
				searchLoading : false,
				asinDataList : [],
				addAsin : []
			},
			addKeywords : {
				visible : false,
				loading :false,
				keywords : [],
				keywordsStr : null,
				period : 8, categoryId : null, endPage : 3
			},
			delAsin : {
				visible : false,
				loading :false,
				checkedAsinS : []
			},
			translation : {},
			keywordsTrends : {}
		}
	},
	computed : {
	},
	props : {
		groupId : {
			required : true
		}
	},
	components: {
		'copy-sub' : COPY_SUB,
		'chart-sub': Chart,
		'page-sub': PAGE_SUB,
		'asin-sub': ASIN_INFO_SUB,
		'keywords-related-list': KEYWORD_RELATED_LIST,
		'keyword-recharge-sub': KEYWORD_RECHARGE_SUB,
		'asin-rank-trends-sub' : ASIN_RANK_TRENDS_SUB
	},
	mounted() {
		let throttledScroll = throttle(this.handleScroll,1000); // 限制1000毫秒执行一次
		this.$refs['el-table'].bodyWrapper.addEventListener('scroll',throttledScroll,true)
	},
	created() {
		this.$options.methods.loadData(this)
	},
	methods: {
		handleScroll() {
			let this_ = this
			if (!this_.$refs['el-table']){
				return
			}
			let tableEl = this_.$refs['el-table'].bodyWrapper
			let rows = tableEl.querySelectorAll('.el-table__row')
			rows.forEach(row => {
				const rect = row.getBoundingClientRect()
				if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
					let rowData = this_.$data.searchData.list[row.rowIndex]
					let keywords = rowData.keywords
					if (!rowData.rankTrends){
						this_.$data.searchData.list[row.rowIndex]['rankTrends'] = []
						this_.$options.methods.loadKeywordsInfo(this_,keywords)
					}
				}
			})
		},
		handleCommand : function(type,data) {
			if (type == 1){
				this.$options.methods.checkKeywordResult(this,data)
			}else {
				this.$options.methods.checkMonitorAsin(this,data)
			}
		},
		delAsinCheck : function(asin) {
			let index = this.$data.delAsin.checkedAsinS.indexOf(asin)
			if (index !== -1){
				 this.$data.delAsin.checkedAsinS.splice(index, 1)
			}else {
				this.$data.delAsin.checkedAsinS.push(asin)
			}
		},
		searchFun : function(this_){
			this_ = this_ || this
			this_.$data.search.page = 1
			this_.$options.methods.loadData(this_)
		},
		openAsinHistoryDialog : function(id,asin) {
			this.$data.asinHistory.visible = true
			let obj = this.$data.searchData.asinData.find(i => i.taskId===id && i.asin === asin)
			this.$data.asinHistory.asinTaskId = obj.id
		},
		openKeywordTrendsDialog: function(keyword) {
			let this_ = this
			this_.$data.searchVolumeShowObj.keyword = keyword
			this_.$data.searchVolumeShowObj.dialogVisible = true
		},
		openAddAsinDialog : function() {
			let this_ = this
			this_.$data.addAsin.visible = true
		},
		openAddKeywordsDialog : function() {
			let this_ = this
			this_.$data.addKeywords.visible = true
		},
		handleInputConfirm(e) {
			let inputValue = this.$data.addKeywords.keywordsStr;
			if (e.ctrlKey) {
				this.$data.addKeywords.keywordsStr += '\n'
				return
			}
			this.$data.addKeywords.keywordsStr = '';
			if (inputValue) {
				let strArr = inputValue.split(/[(\r\n)\r\n]+/).filter(i => i && this.$data.addKeywords.keywords.indexOf(i) === -1)
				this.$data.addKeywords.keywords.push(...strArr)
			}
		},
		openDelAsinDialog : function() {
			let this_ = this
			this_.$data.delAsin.visible = true
		},
		openUpdateKeyword: function(data) {
			this.$data.updateKeywordConfigObj.dialogVisible = true
			this.$data.updateKeywordConfigObj.keywordConfig = data
		},
		openRechargeKeyword: function(data) {
			this.$data.rechargeConfigObj.dialogVisible = true
			this.$data.rechargeConfigObj.keywordTitles.push(data.keywords)
			this.$data.rechargeConfigObj.keywordIds.push(data.id)
		},
		rechargeKeywordSucceed: function() {
			this.$data.rechargeConfigObj.dialogVisible = false
			this.$options.methods.loadData(this)
		},
		handleSizeChange: function(val) {
			this.$data.search.page = 1
			this.$data.search.pageSize = val
			this.$options.methods.loadData(this)
			// 回到顶部
			document.documentElement.scrollTop = 0
		},
		pageChange: function(val) {
			this.$data.search.page = val
			this.$options.methods.loadData(this)
		},
		addKeywordsFun : function(this_) {
			this_ = this_ || this
			let obj = { groupId : this_.groupId}
			let addObj = this_.$data.addKeywords

			obj.keywords = addObj.keywords.map(i => {
				return { keywords : i ,  period : addObj.period,categoryId : addObj.categoryId, endPage : addObj.endPage   }
			})
			this_.$data.addKeywords.loading = true
			api_add_monitoring2(obj).then(res => {
				this_.$data.addKeywords.loading = false
				this_.$data.addKeywords.visible = false
				this_.F_alertMsg('添加成功', 2)
				this_.F_LOGIN()
				this_.$options.methods.loadData(this_)
			}).catch(err => {
				console.error(err)
				this_.$data.addKeywords.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '添加失败'), 4)
			})
		},
		// 删除ASIN的实际方法
		delAsinFun : function(this_) {
			this_ = this_ || this
			this_.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this_.$data.delAsin.loading = true
				let asins = this_.$data.delAsin.checkedAsinS.join(',')
				api_delAsin_monitoring2(this_.groupId,asins).then(res => {
					//关闭遮罩
					this_.$data.delAsin.loading = false
					this_.$data.delAsin.visible = false
					this_.$data.delAsin.checkedAsinS = []
					this_.F_alertMsg('删除成功', 2)
					this_.$options.methods.loadData(this_)
				}).catch(err => {
					//关闭遮罩
					this_.$data.delAsin.loading = false
					this_.F_alertMsg(this_.F_getErrMSg(err, '删除失败'), 4)
				})
			}).catch(() => {
				this_.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
			//开启遮罩
		},
		delKeywords : function(this_,id) {
			this_ = this_ || this
			this_.$confirm('此操作将永久删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this_.$data.loading = true
				api_del_monitoring2(id).then(res => {
					this_.$data.loading = false
					this_.$options.methods.loadData(this_)
					this_.F_alertMsg('删除成功', 2)
				}).catch(err => {
					console.error(err)
					this_.$data.loading = false
					this_.F_alertMsg(this_.F_getErrMSg(err, '删除失败'), 4)
				})
			}).catch(() => {
				this_.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		updateConfig : function(this_) {
			this_ = this_ || this
			let data = this_.$data.updateKeywordConfigObj.keywordConfig
			let obj =  { taskId : data.id,period : data.period }
			api_updateConfig_monitoring2(obj).then(res => {
				this_.$data.updateKeywordConfigObj.keywordConfig.dialogVisible = false
				this_.$options.methods.loadData(this_)
				this_.F_alertMsg('修改成功', 2)
			}).catch(err => {
				console.error(err)
				this_.F_alertMsg(this_.F_getErrMSg(err, '修改失败'), 4)
			})
		},
		loadData: function(this_) {
			this_ = this_ || this
			if (this_.$data.loading) {
				return
			}
			//开启遮罩
			this_.$data.loading = true
			let obj = { ...this_.$data.search  }
			obj.groupId = this_.groupId
			api_page_monitoring2(obj).then(res => {
				let data =  res.data
				data.asinList = new Set(data.asinData.map(i => i.asin))
				this_.$data.keywordsTrends = data.trends
				delete data.trends
				this_.$data.translation = data.translation
				delete data.translation
				data.list = data.list.map(i => {
					i.pageData = JSON.parse(i.pageData || '{}')
					return i
				})
				this_.$data.searchData = data
				this_.$nextTick(() => {
					this_.$refs['el-table'].doLayout()
					this_.handleScroll()
					this_.$options.methods.loadAsinInfo(this_)
				})
				//开启遮罩
				this_.$data.loading = false
			}).catch(err => {
				//关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})

		},
		loadKeywordsInfo : function(this_,keywords) {
			this_ = this_ || this
			let qo = { keywords : keywords }
			let index = this_.$data.searchData.list.findIndex(i => i.keywords === keywords)
			api_keywordsTrends_monitoring2(qo).then(res => {
				let data = res.data
				let obj = this_.$data.searchData.list[index]
				obj.rankTrends = data || []
				this_.$set(this_.$data.searchData.list,index, { ...obj })
			}).catch(err => {
				let obj = this_.$data.searchData.list[index]
				obj.rankTrends =  []
				this_.$set(this_.$data.searchData.list,index, { ...obj })
				console.error(err)
			})
		},
		loadAsinInfo : function(this_) {
			this_ = this_ || this
			let asins = this_.$data.searchData.asinList
			if(asins.size <= 0 || this_.$data.loadAsinLock){
				return
			}
			asins =[...asins]
			asins = asins.filter(i => !this_.$data.asinInfoList.find(j => j.asin === i))
			if (asins.length <= 0) return;
			// 上锁
			this_.$data.loadAsinLock = true
			api_asin_batchAsinInfoQuery_public(asins).then(res => {
				this_.$data.asinInfoList = res.data || []
				// 解锁
				this_.$data.loadAsinLock = false
			}).catch(err => {
				// 解锁
				this_.$data.loadAsinLock = false
				console.error(err)
			})
		},
		searchAsin : function(this_) {
			this_ = this_ || this
			let asin = this_.$data.addAsin.asin
			if (this_.$data.addAsin.asinDataList.find(i => i.asin === asin)){
				this_.$data.addAsin.showAsin = asin
				return
			}
			this_.$data.addAsin.searchLoading = true
			this_.$options.methods.loadAsinData(this_,asin,false).then(asinInfo => {
				this_.$set(this_.$data.addAsin,'showAsin',asin)
				this_.$data.addAsin.asinDataList.push(asinInfo)
			}).finally(() =>  this_.$data.addAsin.searchLoading = false)
		},
		// 增加爬取asin
		addAsinTask : function(this_) {
			this_ = this_ || this
			let obj = { groupId : this_.groupId ,asins : this_.$data.addAsin.addAsin }
			//开启遮罩
			this_.$data.addAsin.loading = true
			api_addAsin_monitoring2(obj).then(res => {
				//关闭弹窗
				this_.$data.addAsin.visible = false
				// 数据还原
				this_.$data.addAsin.addAsin = []
				//关闭遮罩
				this_.$data.addAsin.loading = false
				this_.F_alertMsg('增加成功', 2)
				this_.$options.methods.searchFun(this_)
			}).catch(err => {
				//关闭遮罩
				this_.$data.addAsin.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '增加失败'), 4)
			})
		},
		loadAsinData : function(this_,asin,refresh) {
			this_ = this_ || this
			let data = {
				asin: asin,
				country: 'US',
				refresh : refresh
			}
			return new Promise((resolve, reject) =>
				api_findeByAsin(data).then(res => {
					res.data.imgs = JSON.parse(res.data.imgs || '[]')
					resolve(JSON.parse(JSON.stringify(res.data)))
				}).catch(err => {
					this_.F_alertMsg(this_.F_getErrMSg(err, "检索商品失败"), 4)
					reject(err)
				}) )
		},
		getTimeList: function(startTime, period, size = 10) {
			let timeList = []
			startTime = new Date(startTime) || new Date()
			for (var i = 1; i <= size; i++) {
				let time = 1000 * 3600 * period * i
				time += startTime.getTime()
				timeList.push(new Date(time))
			}
			return timeList
		},
		getChartOption: function(keyword, trends) {
			return fomatSearchTrendsData(keyword, trends)
		},
		getChartOption2 : function(trends) {
			return fomatRankTrendsDataMini(trends)
		},
		checkKeywordResult : function(this_,data) {
			this_ = this_ || this
			let sub = () => import('@/components/template/view/keyword/monitoring2/keyword/keywordResult')
			this_.KEYWORD_ADD_TAB(null, data.keywords + ' 搜索结果', 'keywordResult' + data.keywords, sub, { keywordsData: data })
		},
		checkMonitorAsin: function(this_, data) {
			this_ = this_ || this
			let sub = () => import('@/components/template/view/keyword/monitoring2/asin/list')
			this_.KEYWORD_ADD_TAB(null, data.keywords + ' 监控详情', 'checkMonitorAsin' + data.keywords, sub, { monitorInfo: data })
		},
		toThousands: function(num) {
			return toThousands(num)
		},
		getDistanceTime: function(d1, d2) {
			return getDistanceTime(d1, d2)
		},
		imgSizeSet : function(url,size=100) {
			return imgSizeSet(url,size)
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
		unitConversion: function(v) {
			return unitConversion(v)
		},
		getSymbolByCurrency: function(val){
			return getSymbolByCurrency(val)
		},
		getCountryByValue: function(val) {
			return getCountryByValue(val)
		},
	},
	watch: {},
}
</script>

<style scoped>
.keyword-list-main-div {
	padding: 0 10px;
}

.head-div {
	display: flex;
	text-align: right;
	padding: 10px 20px;
}
.body-div{
	position: absolute;
	top: 66px;
	left: 0;
	right: 0;
	bottom: 64px;
}
/*table*/
.el-table-20220806 {
	height: 100%;
}
.el-table-20220806 .th-dot-div{
	display: inline-block;
	width: 12px;
	background-color: #67C23A;
	height: 12px;
	border-radius: 6px;
}
/*表格关键词列*/
.el-table-20220806 .keywords-box{
	display: flex;
}
.el-table-20220806 .keywords-text-span {

	font-weight: bold;
	margin-right: 10px;

}
.el-table-20220806 .keywords-text-span a{
	color :#f56c6c;
	font-size: 18px;
	padding-bottom: 1px;
	cursor: pointer;
}
.el-table-20220806 .keywords-text-span a:hover {
	border-bottom: 1px dashed currentColor;
}
/*前十商品*/
.asin-box-div {
	width: 710px;
	max-height: 442px;
	min-height: 200px;
	line-height: 21px;
	overflow: hidden;
}
.asin-box-div .asin-div {
	display: inline-block;
	text-align: center;
	margin: 10px;
}
.asin-box-div .asin-div .img-div {
	border-radius: 5px;
	padding: 5px;
	margin-bottom: 5px;
	cursor: pointer;
	border: 1px solid #FFFFFF;
	position: relative;
}
.asin-box-div .asin-div .img-div:hover {
	border: 1px solid #69b9ff;
	box-sizing: border-box;
}
.asin-box-div .asin-div .img-div .ranking-div {
	position: absolute;
	right: 5px;
	top: 5px;
	background-color: #000000;
	height: 20px;
	width: 20px;
	text-align: center;
	line-height: 20px;
	font-size: 12px;
	border-radius: 50%;
	font-weight: bolder;
	color: #FFFFFF;
	opacity: 0.6;
}

/*操作列*/
.operation-div .el-button{
	padding: 7px;
}

/* 修改关键词配置 */
.update-keyword-body {
	padding: 0 20px;
}

.update-keyword-body .list-time-box {
	border: 1px solid #DCDFE6;
	height: 150px;
	overflow-y: scroll;
	padding: 10px 10px;
	text-align: center;
	line-height: 30px;
	color: #606266;
}

.demo-drawer-footer {
	text-align: center;
	position: absolute;
	bottom: 10px;
	left: 0;
	right: 0;
}

.demo-drawer-footer button {
	width: 45%;
}

.tag-title {
	padding-left: 10px;
	border-left: 5px #67c23a solid;
}

.dot-div {
	background-color: currentColor;
	height: 15px;
	margin: 5px auto;
	width: 15px;
	box-shadow: 0 0px 6px 1px currentColor;
	border-radius: 50%;
}
.tab-foot-page-div{
	position: absolute;
	padding: 15px;
	left: 0;
	right: 0;
	bottom: 0;
	text-align: right;
}
.del-asin-card{
	padding: 5px;
	margin-top: 5px;
	position: relative;
}
.del-asin-card > .check-box{
	position: absolute;
	right: 5px;
}
</style>
<style>


.el-table-header-20220806 th {
	background-color: #F9F9F9 !important;
}
</style>